/* eslint-disable no-tabs */
<template>
  <div>

    <v-navigation-drawer
      app
      fixed
      v-model="showMenu"

    >
      <v-list dense>
        <!-- <v-list-item >

            <v-btn icon>
            <v-icon>mdi-flower</v-icon>
            </v-btn>

          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item @click="logout" >
<v-btn icon>
            <v-icon>mdi-logout-variant</v-icon>
</v-btn>
          <v-list-item-content>
            <v-list-item-title>Sortir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      fixed
      dark
      color="#bd595d"
    >
      <v-app-bar-nav-icon @click="toggleMenu"></v-app-bar-nav-icon>

      <v-toolbar-title class="title"></v-toolbar-title>

    </v-app-bar>

  </div>
</template>

<script>

export default {

  data: () => ({
    showMenu: false
  }),
  methods: {
    toggleMenu () {
      this.showMenu = !this.showMenu
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TopToolbar.vue